<template>
  <Layout>
    <div v-if="quotes.length" class="container white-glove">
      <h3 class="mb-2 text-black">{{ client.firstName }}'s Responses</h3>
      <div class="quote-grid">
        <div class="quote-card" v-for="quote in quotes" :key="quote.id">
          <pre>{{ quote }}</pre>
        </div>
      </div>
    </div>
  </Layout>
</template>
<script>
import api from '@/services/api'
import Layout from '@/router/layouts/main'
export default {
  name: 'quote-review',
  components: { Layout },
  data () {
    return {
      quotes: [],
      client: null,
      placeholderImgUrl: require('@/assets/images/knot.svg')
    }
  },
  methods: {
    getQuotes () {
      const ids = (this.$route.query.quotes || '')
        .split(',')
        .filter(q => q)
        .map(id => Number(id))
      const cacheKey = `clientQuotes_${this.$route.params.id}`
      const cached = localStorage.getItem(cacheKey)
      let cachedQuotes = []
      if (cached) {
        try {
          const parsed = JSON.parse(cached).data
          cachedQuotes = Array.isArray(parsed) ? parsed : parsed.data || []
          const hasAll = ids.every(id => cachedQuotes.some(q => q.id === id))
          if (hasAll) {
            this.quotes = cachedQuotes.filter(q => ids.includes(q.id))
          }
        } catch (e) {}
      }
      api
        .get('/api/stylist/clients/' + Number(this.$route.params.id) + '/quotes')
        .then(response => {
          const data = Array.isArray(response.data)
            ? response.data
            : response.data.data || []
          localStorage.setItem(
            cacheKey,
            JSON.stringify({ timestamp: Date.now(), data })
          )
          this.quotes = data.filter(item => ids.includes(item.id))
        })
    },
    fetchClient () {
      api
        .get('/api/stylist/clients/' + Number(this.$route.params.id))
        .then(response => {
          const data = response.data.data
          this.client = Object.assign({ id: parseInt(data.id) }, data.attributes)
        })
    },
    addImages (quote, event) {
      const files = Array.from(event.target.files)
      files.forEach(file => {
        const reader = new FileReader()
        reader.onload = e => {
          const imageObj = {
            id: Date.now() + Math.random(),
            preview: e.target.result,
            url: null,
            file: file,
            isUploading: true,
            serverId: null
          }
          if (!quote.newImages) {
            quote.newImages = []
          }
          quote.newImages.push(imageObj)
          this.uploadImage(quote, imageObj)
        }
        reader.readAsDataURL(file)
      })
      this.$refs[`file-${quote.id}`].value = null
    },
    uploadImage (quote, uploadingImage) {
      const formData = new FormData()
      formData.append('image', uploadingImage.file)
      api
        .post('/api/stylist/white-glove-quotes/images', formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        })
        .then(response => {
          uploadingImage.url = response.data.url
          uploadingImage.serverId = response.data.id
          uploadingImage.isUploading = false
          quote.attributes.images.push({ url: response.data.url, id: response.data.id })
        })
        .catch(() => {
          const idx = quote.newImages.findIndex(img => img.id === uploadingImage.id)
          if (idx !== -1) {
            quote.newImages.splice(idx, 1)
          }
        })
    },
    getQuoteStatusText (quote) {
      const attrs = quote.attributes

      // Check if item has been picked up (pickup_type is "concierge")
      if (attrs.pickup_type === 'concierge') {
        return 'Picked Up'
      }

      if (attrs.status) {
        return attrs.status.replace(/([a-z])([A-Z])/g, '$1 $2')
      }
      return 'Not Submitted'
    },
    formatDate (date) {
      const d = new Date(date)
      return d.getMonth() + 1 + '/' + d.getDate() + '/' + d.getFullYear()
    }
  },
  mounted () {
    document.body.setAttribute('data-layout', 'lightHeader')
    this.fetchClient()
    this.getQuotes()
  }
}
</script>
<style scoped>
.quote-card {
  position: relative;
  border: 1px solid #ccc;
  padding: 15px;
  border-radius: 4px;
  background-color: #fff;
}
.preview {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
.thumb {
  width: 100px;
  height: 100px;
  border: 1px dashed #cccccc;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}
.thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.thumb.placeholder {
  cursor: pointer;
  color: #7d7a7a;
  font-size: 24px;
}
</style>
